import { useMutation } from '@tanstack/react-query';
import { ChangeEvent, FormEvent, useState } from 'react';
import { useParams } from 'react-router';

import { sendMagicLink } from '../../api';
import { EmailView } from './Email.view';

export const EmailContainer = () => {
  const [wasEmailSent, setWasEmailSent] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const { requestId } = useParams<{ requestId: string }>();

  const {
    mutate,
    isLoading: isSendingMagicLink,
    error: magicLinkError,
  } = useMutation({
    mutationFn: () => sendMagicLink({ requestId, newEmail }),
    onSuccess: () => setWasEmailSent(true),
  });

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    mutate();
  };

  const handleOnEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    setNewEmail(event.target.value);
  };

  return (
    <EmailView
      error={magicLinkError}
      email={newEmail}
      wasEmailSent={wasEmailSent}
      onSubmit={handleSubmit}
      handleOnEmailChange={handleOnEmailChange}
      isLoading={isSendingMagicLink}
      onResendVerification={mutate}
    />
  );
};
